import { Badge, Box, Card, CardActionArea, CardContent, CardMedia, Container, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosCloseCircle, IoMdCloseCircle } from "react-icons/io";

const requisitos = [
    { id: 1, icon: <FaCheckCircle color="green" />, texto:"Promedio Mayor o Igual a 7.5" },
    { id: 2, icon: <FaCheckCircle color="green" />, texto:"Deudas" },
    { id: 3, icon: <FaCheckCircle color="green" />, texto:"Sin materias reprobadas" },
    { id: 4, icon: <FaCheckCircle color="green" />, texto:"Sin sanciones" },
    { id: 5, icon: <IoIosCloseCircle color="red" />, texto: "Malla curricular aún en curso"},
    { id: 6, icon: <IoIosCloseCircle color="red" />, texto: "Aprobó más del 25% créditos de la malla"},
    { id: 7, icon: <FaCheckCircle color="green" />, texto: "Sin Evaluación menor a 6 puntos"},
    { id: 8, icon: <FaCheckCircle color="green" />, texto: "Aprobó el MOOC"},
    { id: 9, icon: <FaCheckCircle color="green" />, texto: "Matrícula > 10 años"},
];

export const ResumenEstudiante: React.FC = () =>{
    return(
        <>
        <Box sx={{paddingBottom:"20px"}}>
            <Typography
                variant="h6"
                sx={{
                fontWeight: "bold",
                color: "#243165",
                marginBottom: "24px",
                
                }}
            >
                Datos del estudiante
            </Typography>
            <TableContainer>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{fontWeight:'bold'}}>Identificación: </TableCell>
                            <TableCell>0953394566</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell sx={{fontWeight:'bold'}}>Matrícula: </TableCell>
                            <TableCell>201705100</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell sx={{fontWeight:'bold'}}>Nombre: </TableCell>
                            <TableCell>Luis Enrique Anchundia Solórzano</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell sx={{fontWeight:'bold'}}>Carrera: </TableCell>
                            <TableCell>Computación</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell sx={{fontWeight:'bold'}}>Estado: </TableCell>
                            <TableCell>Activo</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>

        <Box>
            <Typography
                variant="h6"
                sx={{
                fontWeight: "bold",
                color: "#243165",
                marginBottom: "24px",
                
                }}
            >
                Requisitos
            </Typography>
            <Grid container spacing={2}>
                {
                    requisitos.map((req,index)=>(
                        <Grid item key={index}>
                            <Card sx={{ width: 175, borderRadius: 5 }}>
                                <CardContent>
                                    <Grid container spacing={2} display={"flex"} justifyContent={"center"} alignItems={"center"} height={50}>
                                        <Grid item xs={12} md={8} sx={{display:"flex", justifyContent:"center"}}>
                                            <Typography fontSize={11}>{req.texto}</Typography>
                                        </Grid>
                                        <Grid item xs={12} md={4} sx={{display:"flex", justifyContent:"center"}}>
                                            {req.icon}
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))
                }
            </Grid>

        </Box>
        </>
        
        

    )


}

